import {
  FETCH_REGIONAL_INCENTIVES,
  FETCH_REGIONAL_INCENTIVES_SUCCESS
} from '../actionTypes';
import fetchIncentives from '../../api/fetchIncentives';

export const fetchRegionalIncentives = () => {
  return function(dispatch, getState) {
    const { params, config, rpos, api } = getState();
    const options = {
      ...api,
      postalCode: params.postalCode,
      styleId: config.styleId,
      rpos
    };

    dispatch({
      type: FETCH_REGIONAL_INCENTIVES
    });

    fetchIncentives(options).then(data => {
      dispatch({
        type: FETCH_REGIONAL_INCENTIVES_SUCCESS,
        payload: data
      });
    });
  };
};
